// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

import _ from 'lodash'
import Vue from 'vue'

const moduleStore = {
  namespaced: true,
  state: {
    locations: [],
    observations: [],
    equipments: [],
    user: {
      first_name: undefined,
      last_name: undefined,
      email: undefined
    },
    status: 'unknown'
  },
  mutations: {
    modifyNoctuaSkyState (state, { path, newValue }) {
      // mutate NoctuaSky state
      if (path === '') {
        _.assignWith(state, newValue, function (objValue, srcValue, key, object, source) {
          Vue.set(object, key, srcValue)
        })
      } else {
        _.setWith(state, path, newValue, function (nsValue, key, nsObject) {
          Vue.set(nsObject, key, nsValue)
        })
      }
    }
  },
  actions: {
  }
}

export default moduleStore
